module.exports = __webpack_public_path__ + "static/media/bpmeasurex-charger-5.d21f0b0e.jpg";